module.exports = {
  validationToken: process.env.VALIDATION_TOKEN || '12345',
  backEndAPIRoute: process.env.BACKEND_API_ROUTE || 'https://restaurant.danaservers.com',
  };
  